<template>
  <v-card>
    <v-card-title v-if="options.title">
      <span class="headline">{{ options.title }}</span>
    </v-card-title>
    <v-divider></v-divider>
    <v-card-text>
      <ValidationObserver
        ref="form"
        tag="form"
        @submit.prevent="save"
      >
        <ValidationProvider
            rules="required"
            vid="code"
            :name="$t('fields.code').toLowerCase()"
            v-slot="{ errors }"
        >
          <v-text-field
            v-model=" form.code"
            :counter="30"
            :label="$t('fields.code')"
            :error-messages="errors"
          ></v-text-field>
        </ValidationProvider>

        <ValidationProvider
            rules="required"
            vid="schooltypes"
            :name="$t('fields.school_types').toLowerCase()"
            v-slot="{ errors }"
        >
          <v-select
            :items="schoolTypes"
            v-model="form.school_type_id"
            item-text="name"
            item-value="id"
            :label="$t('fields.school_types')"
            :error-messages="errors"
          >
            <template v-slot:append-item>
              <div v-intersect="endIntersect"></div>
            </template>
          </v-select>
        </ValidationProvider>

        <ValidationProvider
            rules="required"
            vid="name"
            :name="$t('fields.name').toLowerCase()"
            v-slot="{ errors }"
        >
          <v-text-field
            v-model=" form.name"
            :counter="30"
            :label="$t('fields.name')"
            :error-messages="errors"
          ></v-text-field>
        </ValidationProvider>
        <ValidationProvider
            rules="required"
            vid="ministerial_code"
            :name="$t('fields.ministerial_code').toLowerCase()"
            v-slot="{ errors }"
            v-if="!form.id"
        >
          <v-text-field
            v-model=" form.ministerial_code"
            :counter="30"
            :label="$t('fields.ministerial_code')"
            :error-messages="errors"
            v-if="!form.id"
          ></v-text-field>
        </ValidationProvider>
    </ValidationObserver>
    </v-card-text>
    <v-card-actions>
      <v-btn @click="save" color="primary">{{ $t('SAVE') }}</v-btn>
      <v-btn @click="cancel">{{ $t('CANCEL') }}</v-btn>
    </v-card-actions>
  </v-card>
</template>
<script>
  import { mapActions, mapState } from 'vuex';

  import { schoolsService } from '../../../utils/services/schools.service';
  import { schoolsTypesService } from '../../../utils/services/schoolsTypes.service';

  export default {
    name: 'SchoolModal',
    data() {
      return {
        stored: null,
        school: {},
        schoolTypes: [],
        form: {
          name: null,
          school_type_id: null,
          ministerial_code: null,
          code: null,
        },
        loading: false,
        paginations: {
          schoolTypes: {
            current_page: 1,
            last_page: 1,
          },
        },
      };
    },
    computed: {
      ...mapState('modal', ['options', 'data']),
    },
    methods: {
      ...mapActions('alert', ['showToast']),
      ...mapActions('modal', ['hideModal', 'loadingModal']),

      async endIntersect(entries, observer, isIntersecting) {
      if (isIntersecting) {
        if (this.paginations.schoolTypes.current_page + 1 <= this.paginations.schoolTypes.last_page) {
          const moreSchoolTypes = await this.fetchSchoolTypes(this.paginations.schoolTypes.current_page + 1);
          this.schoolTypes = [...this.schoolTypes, ...moreSchoolTypes];
        }
      }
    },

      async save() {
        const isValid = await this.$refs.form.validate();
        if (isValid) {
            if (this.options.onSave) {
              this.loadingModal(true);
              this.options.onSave(
                this.form,
                this.errors,
              )
              .then(() => {
                  this.loadingModal(false);
              })
              .catch(error => {
                  this.handleError(error, this.errors);
              });
            }
        }
      },
      cancel() {
        this.hideModal({});
      },
      fetchSchool(id) {
        return schoolsService.get(id)
        .then(response => {
            this.school = response.data.data;
        })
        .catch(error => {
            this.handleError(error, this.errors);
        });
      },
      fetchSchoolTypes(page) {
        return schoolsTypesService.index({
          page: page || 1,
          itemsPerPage: (this.form.school_type_id) ? 1000 : 15,
          filters: {
            sortBy: ['name'],
            sortDesc: [true],
          },
        })
        .then(response => {
          const { current_page, last_page } = response.data.meta;
          this.paginations.schoolTypes.current_page = current_page;
          this.paginations.schoolTypes.last_page = last_page;
          return response.data.data;
        })
        .catch(error => {
          console.log(error);
          this.handleError(error, this.errors);
            return [];
        });
      },
    },
    async created() {
      this.loadingModal(true);
      if (this.data.stored.id) {
        await this.fetchSchool(this.data.stored.id);
        this.form = {
          id: this.data.stored.id,
          name: this.school.name,
          code: this.school.code,
          ministerial_code: this.school.ministerial_code,
          school_type_id: this.school.school_type_id,
        };
      }
      this.schoolTypes = await this.fetchSchoolTypes();
      this.loadingModal(false);
    },
  };
</script>
